var render, staticRenderFns
import script from "./ModelFields.vue?vue&type=script&lang=js&"
export * from "./ModelFields.vue?vue&type=script&lang=js&"
import style0 from "./ModelFields.vue?vue&type=style&index=0&id=8161720c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8161720c",
  null
  
)

export default component.exports